import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Notification } from "../config/Notification";

interface NotificationState {
  notifications: Notification[];
  unreadCount: number;
}

const initialState: NotificationState = {
  notifications: [],
  unreadCount: 0,
};

const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    addNotification: (state, action: PayloadAction<Notification>) => {
      state.notifications.unshift(action.payload);
      state.unreadCount += 1;
    },
    markAllAsRead: (state) => {
      state.notifications = state.notifications.map((notification) => ({
        ...notification,
        read: true,
      }));
      state.unreadCount = 0;
    },
    setNotifications: (state, action: PayloadAction<Notification[]>) => {
      state.notifications = action.payload;
      state.unreadCount = action.payload.filter((n) => !n.read).length;
    },
    clearNotifications: (state) => {
        state.notifications = [];
        state.unreadCount = 0;
      },
  },
});

export const { addNotification, markAllAsRead, setNotifications, clearNotifications } =
  notificationSlice.actions;

export default notificationSlice.reducer;
